import { Controller } from '@hotwired/stimulus'
import { autofill } from '@mapbox/search-js-web'

// Connects to data-controller="address-search"
export default class extends Controller {
  static targets = [
    'addressLine1',
  ]

  declare readonly addressLine1Target: HTMLFormElement

  static values = {
    mapboxPublicToken: String,
  }

  declare mapboxPublicTokenValue: string

  connect () {
    if (!this.mapboxPublicTokenValue) {
      console.warn('Address aucompletion is disabled because Mapbox access token is not set.')
      return
    }

    autofill({
      accessToken: this.mapboxPublicTokenValue,
      options: {
        // Only return results in the US
        country: 'US',
        // If the language is not set, Mapbox defaults to 'en'. This causes some counties like San
        // Francisco County to be returned as just "San Francisco", which prevents matching with
        // the census list directly.
        language: '',
      },
    })

    // Note that this is added specifically due to how the Mapbox address
    // autofill lib works. Mapbox will automatically append "address-search"
    // to the `name` attribute of the text input element that has the
    // `autocomplete` attribute set to "address-line1". That results in
    // the following HTML:
    //
    // <input ... name="employer_profile[address_line1] address-search" autocomplete="address-line1`>
    //
    // However this unfortunately messes with how the params are passed to
    // the controller in Rails, with the address_line1 param formatted as:
    //
    // { address_line1: { " address_search": "160 Spear St" }}
    //
    // These two lines below change the `name` attribute of the text input
    // to drop the "address-search" that is automatically appended so it's only
    // "employer_profile[address_line1]" to play nicely with Rails conventions
    const name = this.addressLine1Target.name.split(' ')[0]
    this.addressLine1Target.name = name
  }
}
